export const CONTAINER_TYPE_OMR_ZONE = "housewaste_characterisation_zone";

/** Carac « en benne » : plusieurs historiques / images (vs une seule capture zone). */
export const isBenneCharacterization = (historyMaterial) =>
  Array.isArray(historyMaterial) && historyMaterial.length > 1;

export const REGULATION_TYPES = {
  CLASSIC: "classic",
  DECREE_1199: "1199",
  EPR: "EPR",
  RHW: "RHW",
};

const REGULATION_CHIP_ORDER = [
  REGULATION_TYPES.CLASSIC,
  REGULATION_TYPES.DECREE_1199,
  REGULATION_TYPES.EPR,
  REGULATION_TYPES.RHW,
];

export const DEFAULT_REGULATION_TYPE = REGULATION_TYPES.DECREE_1199;

export const getRegulationChipIndex = (characterizationType) => {
  const index = REGULATION_CHIP_ORDER.indexOf(characterizationType);
  return index >= 0 ? index : 1;
};

export const getValidRegulationType = (regulationType) =>
  REGULATION_CHIP_ORDER.includes(regulationType)
    ? regulationType
    : DEFAULT_REGULATION_TYPE;

/** Regulation mode derived from container physical type (source of truth). */
export const getRegulationTypeFromContainer = (container) => {
  if (container?.type === CONTAINER_TYPE_OMR_ZONE) {
    return REGULATION_TYPES.RHW;
  }
  return DEFAULT_REGULATION_TYPE;
};

export const getVisibleRegulationTypes = (containerRegulationType) => {
  if (containerRegulationType === REGULATION_TYPES.RHW) {
    return [REGULATION_TYPES.RHW];
  }
  return REGULATION_CHIP_ORDER.slice(0, 3);
};

export const getRegulationChipLabel = (regulationType, t) => {
  const chips = [
    t("No regulation"),
    `${t("Decree")} n° 2021-1199`,
    t("France EPR recycling channel"),
    t("OMR"),
  ];
  const index = getRegulationChipIndex(regulationType);
  return chips[index] || chips[1];
};

export const getEffectiveThresholdCm = (
  characterizationType,
  sizeThreshold,
) => {
  if (characterizationType === REGULATION_TYPES.DECREE_1199) return 40;
  if (
    characterizationType === REGULATION_TYPES.RHW ||
    characterizationType === "OMR"
  ) {
    return 0;
  }

  return typeof sizeThreshold === "number" ? sizeThreshold : 40;
};
